import { getMarginTradingOption } from '@src/containers/Dealer/CustomerMarginConfiguration/mappers';
import type { CustomerMarginConfiguration } from '@src/containers/Dealer/CustomerMarginConfiguration/types';

export const SPOT_ON_MARGIN_ACCOUNT_ERROR = 'Spot securities cannot be booked to margin-enabled market accounts';

export const NON_SPOT_ON_NON_MARGIN_ACCOUNT_ERROR =
  'Non-spot securities cannot be booked to non-margin market accounts';

export function isMarketAccountMarginTradingEnabled(
  configurations: CustomerMarginConfiguration[] | undefined,
  marketAccount: string | undefined
): boolean | undefined {
  if (!marketAccount || !configurations) {
    return undefined;
  }

  const config = configurations.find(configuration => configuration.MarketAccount === marketAccount);
  return getMarginTradingOption(config?.MarginTrading) === 'enabled';
}

export function getCustomerTradeMarginRestrictionError({
  isSpotSecurity,
  isMarginTradingEnabled,
}: {
  isSpotSecurity: boolean | undefined;
  isMarginTradingEnabled: boolean;
}): string | undefined {
  if (isSpotSecurity == null) {
    return undefined;
  }

  if (isMarginTradingEnabled && isSpotSecurity) {
    return SPOT_ON_MARGIN_ACCOUNT_ERROR;
  }

  if (!isMarginTradingEnabled && !isSpotSecurity) {
    return NON_SPOT_ON_NON_MARGIN_ACCOUNT_ERROR;
  }

  return undefined;
}
